import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TermsAcceptance from "@/components/Politica";
import { useAuth } from "@/hooks/useAuth";

export function PrivacyPolicyScreen() {
  const { user, acceptPrivacyPolicy, loading } = useAuth();
  const navigate = useNavigate();
  const [accepted, setAccepted] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!user) {
      navigate("/auth", { replace: true });
    }
  }, [user, navigate]);

  useEffect(() => {
    if (user?.privacyAccepted) {
      navigate("/dashboard", { replace: true });
    }
  }, [user, navigate]);

  const handleAccept = async () => {
    if (!user) return;
    setSaving(true);
    setError(null);

    try {
      await acceptPrivacyPolicy(user.id);
      navigate("/dashboard", { replace: true });
    } catch (err: any) {
      setError(err?.message || "No se pudo guardar la aceptación. Intenta de nuevo.");
    } finally {
      setSaving(false);
    }
  };

  if (!user) {
    return null;
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(180deg, #0f172a 0%, #2563eb 55%, #38bdf8 100%)',
        color: '#f8fafc',
        padding: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '760px',
          background: '#ffffff',
          borderRadius: '28px',
          boxShadow: '0 20px 80px rgba(15,23,42,0.18)',
          overflow: 'hidden',
        }}
      >
        <div style={{ padding: '32px', background: '#0f172a', color: '#e2e8f0' }}>
          <img
            src="/logo.png"
            alt="WingDrive"
            style={{ height: 56, marginBottom: 16, objectFit: 'contain' }}
          />
          <h1 style={{ margin: 0, fontSize: '2rem', fontWeight: 800, color: '#38bdf8' }}>
            Política de Privacidad
          </h1>
          <p style={{ marginTop: 12, lineHeight: 1.7, color: '#cbd5e1' }}>
            Para continuar usando WingDrive debes aceptar la política de privacidad y el tratamiento de datos.
          </p>
        </div>

        <div style={{ padding: '32px', background: '#f8fafc', color: '#0f172a' }}>
          <div style={{ marginBottom: 24 }}>
            <p style={{ margin: '0 0 12px 0', fontSize: 18, fontWeight: 700 }}>
              Aceptación obligatoria
            </p>
            <p style={{ margin: 0, lineHeight: 1.7, color: '#475569' }}>
              Si te registraste con Google, todavía necesitas aceptar nuestras políticas para activar tu cuenta en la app.
            </p>
          </div>

          <TermsAcceptance value={accepted} onChange={setAccepted} />

          {error && (
            <div style={{ marginTop: 16, color: '#dc2626', fontWeight: 600 }}>{error}</div>
          )}

          <button
            onClick={handleAccept}
            disabled={!accepted || saving || loading}
            style={{
              marginTop: 24,
              width: '100%',
              background: accepted ? '#0ea5e9' : '#94a3b8',
              color: '#ffffff',
              border: 'none',
              borderRadius: 14,
              padding: '16px 20px',
              fontSize: 16,
              fontWeight: 700,
              cursor: accepted && !saving && !loading ? 'pointer' : 'not-allowed',
              transition: 'background 200ms ease',
            }}
          >
            {saving || loading ? 'Guardando...' : 'Aceptar y continuar'}
          </button>
        </div>
      </div>
    </div>
  );
}
